import type { PlatformUser } from '@/types/api'

const TOKEN_KEY = 'integrated_platform_token'
const USER_KEY = 'integrated_platform_user'
const REMEMBERED_ACCOUNT_KEY = 'integrated_platform_remembered_account'

function readStorage(key: string): string | null {
  return localStorage.getItem(key) || sessionStorage.getItem(key)
}

function writeStorage(key: string, value: string, persistent: boolean): void {
  localStorage.removeItem(key)
  sessionStorage.removeItem(key)

  const storage = persistent ? localStorage : sessionStorage
  storage.setItem(key, value)
}

export function getToken(): string | null {
  return readStorage(TOKEN_KEY)
}

export function setToken(token: string, persistent = true): void {
  writeStorage(TOKEN_KEY, token, persistent)
}

export function getUser(): PlatformUser | null {
  const user = readStorage(USER_KEY)

  if (!user) return null

  try {
    const parsedUser = JSON.parse(user) as PlatformUser

    if (parsedUser.role === '超级管理员') {
      return {
        ...parsedUser,
        role: 'super_admin',
        roleName: '超级管理员'
      }
    }

    return parsedUser
  } catch {
    clearAuth()
    return null
  }
}

export function setUser(user: PlatformUser, persistent = true): void {
  writeStorage(USER_KEY, JSON.stringify(user), persistent)
}

export function syncStoredUser(user: PlatformUser): void {
  const persistent = localStorage.getItem(TOKEN_KEY) !== null
    || localStorage.getItem(USER_KEY) !== null

  writeStorage(USER_KEY, JSON.stringify(user), persistent)
}

export function clearAuth(): void {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  sessionStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(USER_KEY)
}

export function getRememberedAccount(): string {
  return localStorage.getItem(REMEMBERED_ACCOUNT_KEY) || ''
}

export function setRememberedAccount(account: string): void {
  if (account) {
    localStorage.setItem(REMEMBERED_ACCOUNT_KEY, account)
  } else {
    localStorage.removeItem(REMEMBERED_ACCOUNT_KEY)
  }
}
